"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetShippingSelectionHandler = resetShippingSelectionHandler;
var _types = require("../types");
var _utils = require("../utils");
async function resetShippingSelectionHandler() {
  const response = await fetch(_types.RequestUrl.ResetFreeShippingSelection, (0, _utils.getHttpRequestSettings)());
  return (0, _utils.convertToCamelCase)(await response.json());
}
